import { carouselItems } from '@/pages/home/mocks/data';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium bg-primary-100 text-primary-700 rounded-full mb-3">
            深度专题
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900">焦点专题</h2>
          <p className="text-foreground-500 mt-2 text-sm">精选深度八卦专题，一次看个够</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {carouselItems.map((item) => (
            <a
              key={item.id}
              href="#carousel"
              className="group rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer flex flex-col"
            >
              <div className="relative overflow-hidden aspect-[4/3]">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 bg-black/60 text-white text-xs font-medium rounded whitespace-nowrap">
                  {item.tag}
                </span>
                <span className="absolute bottom-3 right-3 px-2 py-0.5 bg-black/50 text-white text-xs rounded whitespace-nowrap">
                  {item.count}
                </span>
              </div>
              <div className="p-4 flex-1 flex flex-col">
                <h3 className="text-sm font-semibold text-foreground-900 line-clamp-2 leading-relaxed mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed mt-auto">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}